import React, { useState, useEffect } from "react";
import { getUserId, getAccesstoken } from "../../utils/auth";
import { fetchOrdersWithDetails } from "../../api/OrderHelper";
import { capitalizeWords } from "../../utils/helpers";
import { formatDateDDMMYYY, formatDBDateDDMMYYY } from "../../utils/utils";

const User_orders = () => {
  const [orders, setOrders] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const user_id = getUserId();
  const access_token = getAccesstoken();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const ordersWithDetails = await fetchOrdersWithDetails(user_id, access_token);
      setOrders(ordersWithDetails);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
      setLoading(false);
    }
  };

  const toggleOrderExpansion = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="dashrboard_grey_section p-3 p-sm-4">
        <h1 className="font-lg mb-4">Order History</h1>

        {orders.map((order) => (
          <div key={order.id} className="card_orders p-3 p-sm-5 mb-3">
            <div 
              className="order-container mb-4" 
              style={{ cursor: 'pointer' }}
              onClick={() => toggleOrderExpansion(order.id)}
            >
              <div className="order-detail">
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                  <p className="text-content mb-2 mb-sm-0 text-center text-sm-start">
                    Total Amount: ₹{order.total_amount}
                    <br />
                    Order Date: {formatDBDateDDMMYYY(order.created_at)}
                  </p>
                </div>
              </div>
            </div>

            {/* Products container with responsive padding */}
            <div className="products-container">
              {order.products.slice(0, 2).map((product) => (
                <div key={product.id} className="order_details_card p-2 p-sm-4 mb-3">
                  <ProductCard product={product} />
                </div>
              ))}

              {expandedOrder === order.id && order.products.length > 2 && (
                <div className="additional-products">
                  {order.products.slice(2).map((product) => (
                    <div key={product.id} className="order_details_card p-2 p-sm-4 mb-3">
                      <ProductCard product={product} />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* View More button with better mobile styling */}
            {order.products.length > 2 && (
              <button
                className="btn btn-link w-100 mt-2"
                style={{ fontSize: 'calc(0.8rem + 0.2vw)' }}
                onClick={() => toggleOrderExpansion(order.id)}
              >
                {expandedOrder === order.id ? "Show Less" : "View More Products"}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// Separate component for product card to keep code DRY
const ProductCard = ({ product }) => (
  <div className="cart-item w-100">
    <div className="cart-box d-flex flex-column flex-sm-row align-items-center align-items-sm-start">
      <a href={`/product/${product.product_id}`} className="cart-image mb-3 mb-sm-0 me-sm-3">
        <img
          src={`../assets/images/products/${product.productDetails.product_image}`}
          className="img-fluid blur-up lazyload rounded-corners"
          alt={product.productDetails.name}
          style={{ 
            width: '80px', 
            height: '80px', 
            objectFit: 'cover',
            '@media (min-width: 576px)': {
              width: '100px',
              height: '100px',
            }
          }}
        />
      </a>

      <div className="cart-content flex-grow-1 text-center text-sm-start">
        <a href={`/product/${product.product_id}`}>
          <h5 className="name" style={{ fontSize: 'calc(0.9rem + 0.3vw)' }}>
            {product.productDetails.name}
          </h5>
        </a>

        <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3 justify-content-center justify-content-sm-start">
          <div className="price-detail">
            <h6 className="price mb-0">
              <span className="theme-color">₹{product.unit_price}</span>
              <span className="text-content ms-2">/ 1 item</span>
            </h6>
          </div>

          <div className="cart-item-quantity">
            <span className="text-content">Qty: {product.quantity}</span>
          </div>
        </div>

        <div className="price-detail mt-2">
          <h6 className="price theme-color mb-0">
            Total: ₹{(product.quantity * product.unit_price).toFixed(2)}
          </h6>
        </div>
      </div>
    </div>
  </div>
);

// Add these CSS styles to your stylesheet
const styles = `
  @media (max-width: 576px) {
    .card_orders {
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .order_details_card {
      margin-bottom: 10px;
    }

    .cart-image img {
      margin: 0 auto;
    }

    .cart-content {
      width: 100%;
    }

    .price-detail {
      text-align: center;
    }

    .cart-item-quantity {
      text-align: center;
    }
  }

  .order_details_card {
    background: #fff;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .order_details_card:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
`;

export default User_orders;
